import React, { Component } from 'react';
import { Container, Grid, Header, Segment } from 'semantic-ui-react';
import { LocaleContext } from '../locale-context';

const src = '/assets/images/wireframe/white-image.png';
const translations = {
    en: {
        header1: 'Leadership',
        header2: 'Discover, Feel',
        header3: 'Inspire',
        buttonFindMore: 'Find Out More',
        header4: 'Happy Customers',
        testimonial:
            'Bogdan is a great person to work with. He knows how to motivate, inspire and energise people so that they push to achieve their own goals and those of the company.',
        services: 'Services',
        homeTitle: 'Who are we',
        homeLabel1: 'Assistants for your growth.',
        homeLabel2: 'We are passionate about people development.',
        homeLabel3: 'We are motivated by the progress of managerial teams.',
        homeLabel4: 'We are dedicated to building a performance oriented enviroment within your company.',
        homeLabel5: 'Our mission is to assist our partners in improving their leadership abilities by using modern instruments, specific for the coaching, training and mentoring processes.',
        homeLabel6: 'Our goal is that every manager with whom we interact, will reach the level which he desires as an individual and also reaching the desired level for his team.',
        homeLabel7: 'Choose a complex program of development in which we build approaches for your specific profile and we check their sustainability, or go for proven "shortcuts": one hour long consulting meetings in which we share with you clear management and leadership advices; 90 minutes trainings in which we will deliver you a practical and concise instrument for developing soft skills, based on the topic which you choose.'
    },
    ro: {
        header1: 'Leadership',
        header2: 'Dezvolta, Simte',
        header3: 'Inspira',
        buttonFindMore: 'Afla mai multe',
        header4: 'Clienti Fericiti',
        testimonial:
            'Bogdan stie cum sa motiveze, inspire si sa energizeze oamenii. Astfel, ei reusesc sa isi atinga atat scopurile personale cat si cele ale companiilor pentru care lucreaza.',
        services: 'Servicii',
        homeTitle: 'Cine suntem noi',
        homeLabel1: 'Un sprijin in progresul tau.',
        homeLabel2: 'Suntem pasionati de dezvoltarea oamenilor. ',
        homeLabel3: 'Suntem motivati de progresul echipelor manageriale.',
        homeLabel4: 'Suntem dedicati construirii unui mediu orientat spre performanta, in cadrul business-ului tau.',
        homeLabel5: 'Misiunea noastra este de a ne ajuta partenerii sa-si imbunatateasca abilitatile de leadership, prin utilizarea instrumentelor moderne, specifice proceselor de coaching, training si mentoring.',
        homeLabel6: 'Obiectivul nostru este ca fiecare manager cu care interactionam sa ajunga la nivelul pe care si-l doreste atat pentru el ca individ si profesionist, cat si pentru echipa pe care o conduce.',
        homeLabel7: 'Opteaza pentru un program complex in care construim abordari adaptate stilului tau si le verificam eficacitatea sau opteaza pentru "scurtaturi": sedinte de consultanta cu durata de o ora in care iti oferim sfaturi pentru progresul tau si al echipei tale; traininguri de 90 de minute in care iti furnizam un instrument practic si concis pentru dezvoltarea competentelor soft, pe subiecte alese de tine. '
    }
};
const Service = ({ title, url, index }) => (
    <Grid.Column>
        <div className="section-box">
            <div
                className={`section-picture section-picture-${(index % 3) + 1}`}
            >
                &nbsp;
            </div>
            <h3 className="section-heading">
                <span
                    className={`section-heading-span section-heading-span-${(index %
                        3) +
                        1}`}
                >
                    <a href="/services" style={{ color: 'white' }}>
                        {' '}
                        {title}
                    </a>
                </span>
            </h3>
        </div>
    </Grid.Column>
);

const serviceDetails = [
    {
        title: 'TRAIN FOR LEADERSHIP',
        url: '#'
    },
    {
        title: 'START COACHING',
        url: '#'
    },
    {
        title: 'SESIUNI DE COACHING SUPERVIZATE',
        url: '#'
    },
    {
        title: 'COACHING INDIVIDUAL',
        url: '#'
    },
    {
        title: 'COACHING DE ECHIPA',
        url: '#'
    },
    {
        title: 'CONSULTANTA PENTRU DEZVOLTARE',
        url: '#'
    }
];

const TestimonialImage = ({ imageNumber }) => (
    <Grid.Row>
        <img
            src={require(`../images/nat-${imageNumber}-large.jpg`)}
            className="testimonial-photo"
        />
    </Grid.Row>
);

const TestimonialImageBig = () => (
    <Grid.Row>
        <img
            src={require(`../images/Bogdan.jpg`)}
            className="testimonial-photo-big"
        />
    </Grid.Row>
);
class Home extends Component {
    render() {
        const { language } = this.props;
        const labels = translations[language];

        return (
            <React.Fragment>
                <section className="cover cover-header">
                    <div className="text-box">
                        <h1 className="heading-primary">
                            <span className="heading-primary-main">
                                {labels.header1}
                            </span>
                            <span className="heading-primary-sub">
                                {labels.header2}
                            </span>
                            <span className="heading-primary-sub">
                                {labels.header3}
                            </span>
                        </h1>

                        <a
                            href="/services"
                            className="btn btn-white btn-animated"
                        >
                            {labels.buttonFindMore}
                        </a>
                    </div>
                </section>

                <Container style={{ marginTop: '4em' }}>
                    <Grid stackable columns="equal">
                        <Grid.Column className="testimonial-composition">
                            <TestimonialImageBig/>
                        </Grid.Column>
                        <Grid.Column className="testimonial-details">
                            <h2 className="heading-secondary">
                                {labels.homeTitle}
                            </h2>                          
                            <p className="paragraph">{labels.homeLabel5}</p>
                            <p className="paragraph">{labels.homeLabel6}</p>
                        </Grid.Column>
                    </Grid>
                </Container>

                <Container style={{ marginTop: '4em' }}>
                    <Grid stackable columns="equal">
                        <Grid.Column className="testimonial-details">                       
                            <p className="paragraph">{labels.homeLabel7}</p>
                        </Grid.Column>
                    </Grid>
                </Container>


                <section className="section-services">
                    <div className="center-text margin-bottom-big">
                        <h2 className="heading-white">{labels.services}</h2>
                    </div>
                    <Container stlye={{ padding: '14rem' }}>
                        <Grid stackable columns={3}>
                            {serviceDetails.map((section, index) => (
                                <Service
                                    {...section}
                                    index={index}
                                    key={index}
                                />
                            ))}
                        </Grid>
                    </Container>
                </section>

                <Container style={{ marginTop: '4em' }}>
                    <Grid stackable columns="equal">
                        <Grid.Column className="testimonial-composition">
                            {[1, 2, 3].map(number => (
                                <TestimonialImage
                                    imageNumber={number}
                                    key={number}
                                />
                            ))}
                        </Grid.Column>
                        <Grid.Column className="testimonial-details">
                            <h2 className="heading-secondary">
                                {labels.header4}
                            </h2>
                            <h3 className="heading-tertiary">
                                RICHARD KLOOSTERMAN
                            </h3>
                            <span>Intersoft Solutions</span>
                            <p className="paragraph">{labels.testimonial}</p>

                            <a href="/testimonials" className="btn-text">
                                Learn more &rarr;
                            </a>
                        </Grid.Column>
                    </Grid>
                </Container>
                
            </React.Fragment>
        );
    }
}

const TranslatedComponent = props => (
    <LocaleContext>
        {value => <Home language={value} {...props} />}
    </LocaleContext>
);

export default TranslatedComponent;



// WEBPACK FOOTER //
// ./src/components/Home.js